import * as React from "react";
import { Journey, StationDefinition } from "../api/api-data-model";
import { format, differenceInMinutes } from "date-fns";
import { getClassFromConfidValue } from "../utils/confidence-colors";
import DetailsIcon from "./DetailsIcon";
import TransilienLineIcon from "./TransilienLineIcon";
import ReactTooltip from "react-tooltip";
import ConfidExplaination from "./ConfidExplaination";
import picto_start from "../resources/images/placeholder.png";
import picto_end from "../resources/images/finish-flag.png"

interface IJourneyTileProps {
  journey: Journey;
  startStation: StationDefinition;
  endStation: StationDefinition;
  onClick?: (journey: Journey) => void;
}

export default class JourneyTile extends React.PureComponent<
  IJourneyTileProps
> {
  constructor(props: IJourneyTileProps) {
    super(props);
    this.handleTileClicked = this.handleTileClicked.bind(this);
  }

  private handleTileClicked() {
    // -- HISTORY DISABLED
    /*if (this.props.onClick) {
      this.props.onClick(this.props.journey);
    }*/
  }

  render() {
    let minutes = Math.abs(
      differenceInMinutes(
        this.props.journey.departure_datetime,
        this.props.journey.arrival_datetime
      )
    );
    let hours = Math.floor(minutes / 60);
    minutes = minutes - hours * 60;
    let timeInfo = "";
    if (hours > 0) timeInfo += hours.toString() + "h";
    if (minutes > 0) timeInfo += minutes.toString() + "min";

    let startSection = this.props.journey.sections[0];
    let endSection = this.props.journey.sections[
      this.props.journey.sections.length - 1
    ];

    let mode = this.props.journey.sections[0].mode.toUpperCase();
    let line = this.props.journey.sections[0].line;
    let num_marche = this.props.journey.sections[0].num_marche;
    let num_marcheList = num_marche.split(" / ");
    if (num_marcheList.length > 1) {
      num_marcheList = num_marcheList.sort((a, b) => a.localeCompare(b));
      num_marcheList[0] === num_marcheList[1] ? num_marche = num_marcheList[0] : num_marche = num_marcheList[0] + " / " + num_marcheList[1];
    }
    let network = this.props.journey.sections[0].network.toUpperCase();

    return (
      <div className="row journey-tile" onClick={this.handleTileClicked}>
        <DetailsIcon className="details-ico" width="2rem" />
        <div className="indic-container">
          <div
            data-tip
            data-for={"tind-" + this.props.journey.id + "-" + this.props.journey.index}
            className={
              "confid-indic " +
              getClassFromConfidValue(this.props.journey.percent_on_time)
            }
          >
            {this.props.journey.percent_on_time === -1 ? "N.D." : this.props.journey.percent_on_time.toString() + "%"}
          </div>
          <ReactTooltip
            id={"tind-" + this.props.journey.id + "-" + this.props.journey.index}
            place="right"
            effect="solid"
          >
            <ConfidExplaination
              confidence={this.props.journey.percent_on_time}
              delay_threshold={this.props.journey.delay_threshold}
              i18nKey = {
                this.props.journey.percent_on_time === -1 ? "confid_explain_nd" :
                network.includes('TRENITALIA') ? "confid_explain_trenitalia" : 
                network.includes('RENFE') ? "confid_explain_renfe" : "confid_explain"
              }
            />
          </ReactTooltip>
        </div>
        <div className="train-journey">
          <div className="journey-details">
            <span>
              {timeInfo} - {mode}{" "}
            </span>
            {mode === "TRANSILIEN" && (
              <TransilienLineIcon line={line} width="1rem" />
            )}
            {mode !== "TRANSILIEN" && (
              <span>{"n° "}<b>{num_marche}</b></span>
            )}
          </div>
          <div className="station start">
            <div className="hour">
              {format(startSection.departure_datetime, "HH:mm")}
            </div>
            <div className="line"></div>
            <div className="line-point">
              <img
                src={picto_start}
                alt="Origine"
              />
            </div>
            <span className="station-name">{this.props.startStation.name}</span>
          </div>
          <div className="station">
            <div className="hour"></div>
            <div className="line"></div>
          </div>
          <div className="station end">
            <div className="hour">
              {format(endSection.arrival_datetime, "HH:mm")}
            </div>
            <div className="line"></div>
            <div className="line-point">
              <img
                src={picto_end}
                alt="Destination"
              />
            </div>
            <span className="station-name">{this.props.endStation.name}</span>
          </div>
        </div>
      </div>
    );
  }
}
